// src/utils/suppressWarnings.ts
export function suppressNonCriticalWarnings() {
  // 抑制非關鍵警告
  const originalConsoleWarn = console.warn;
  const originalConsoleError = console.error;
  
  console.warn = (...args: any[]) => {
    const message = args[0];
    if (typeof message === 'string') {
      // 抑制特定的警告
      if (message.includes('Warning:') && 
          (message.includes('componentWillReceiveProps') || 
           message.includes('componentWillMount') ||
           message.includes('componentWillUpdate'))) {
        return;
      }
    }
    originalConsoleWarn.apply(console, args);
  };
  
  console.error = (...args: any[]) => {
    const message = args[0];
    if (typeof message === 'string') {
      // 抑制特定的錯誤
      if (message.includes('Warning:') || 
          message.includes('DeprecationWarning')) {
        return;
      }
    }
    originalConsoleError.apply(console, args);
  };
}
